// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guestbox[data-v-138e9d22]{margin:0 auto;line-height:46px;text-align:left;font-size:15px;color:#676767}.gb-td[data-v-138e9d22]{padding:8px 12px}.gb-td.label[data-v-138e9d22]{line-height:1}.age[data-v-138e9d22]{font-size:14px;padding-top:5px}.btn[data-v-138e9d22]{width:48px;height:48px;line-height:1;border-radius:50%;font-size:30px;padding:4px}.label[data-v-138e9d22]{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
